import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
//import axios from 'axios';
import axios_api from '../Api';

import Loader from './common/Loader';
import UserDataConfirmationModal from './common/UserDataConfirmationModal';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import default_photo from '../img/default_photo.png'


function OrderButton({positions, order}) {

  return positions ? (order ? (
      <button className="m-5 lk-order-button" onClick={() => console.log("вызвали модал экстенд")} data-bs-toggle="modal" data-bs-target="#modalExtendOrder">
        <p className="m-3">оформить заказ</p>
      </button> 
    ) : (
      <button className="m-5 lk-order-button" onClick={() => console.log("вызвали модал")} data-bs-toggle="modal" data-bs-target="#userDataConfirmModal">
        <p className="m-3">оформить заказ</p>
      </button> 
    )
  ) : (
    <button className="m-5 lk-order-button lk-button-disabled" onClick={() => console.log("в корзине нет товаров")} >
      <p className="m-3">оформить заказ</p>
    </button> 
  );
}

function OrderPanel ({order, positions, priceSum, CreateOrderClick, selectedYear}) {


  return (
    <>
      <UserDataConfirmationModal
        modalId="userDataConfirmModal"
        selectedYear={selectedYear}
        handleClick={CreateOrderClick}
      />
      
      <div className="modal fade" id="modalExtendOrder" tabIndex="-1" aria-labelledby="modalExtendOrderLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h2 className="modal-title fs-5" id="modalExtendOrderLabel">Заказ на выбранный год уже оформлен</h2>
              <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Расширить состав заказа можно через заключение допсоглашения к договору. Пожалуйста свяжитесь с АСНП ЦВКК по телефону +7(495)225-50-31 </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn lk-button" data-bs-dismiss="modal">Ок</button>
            </div>
          </div>
        </div>
      </div>

      <div className="card m-2 cart-menu">
        <div className="card-header">Ваша корзина</div>  
        <div className="card-body text-center">
          <div className="row my-2">
            <p>Товары и услуги: ({positions})</p>
            <b>{priceSum} рублей</b>
            <p className="fw-light">в том числе НДС 22%</p>
          </div> 
         </div>       
        <OrderButton 
          positions={positions}
          order={order}
        />
      </div>
    </>
  );
}

/** 
function ProductCard({id, nomenclature, price, selected, photo, onClick}){
  const media_url = useContext(MEDIA_URL);

  return(
    <div className="card m-3 product-card">
      <div className="card-body">
        <div className="row">
          <div className="col-2">
            <img src={photo ? media_url + photo : default_photo} alt="Product" className="" width="130" height="130"></img>
          </div>
          <div className="col-7">
              <div className="card-title"> 
              </div>
            <p>{nomenclature.name}</p>
          </div>
          <div className="col-3">
            <p className='position-absolute top-0 end-0 m-4'><b>{price}</b> рублей</p> 
            <div className='position-absolute bottom-0 end-0 m-4'>
              {selected === true ? 
                <button className="lk-disabled-button">В корзине</button> : 
                <button className="lk-button" onClick={onClick}>Добавить в корзину</button>
              }
            </div>
          </div>
        </div>

      </div>    
    </div> 
  );
}
*/

function ProductInCart ({nomenclature, removeProductClick, IncreaseProductCountClick, DecreaseProductCountClick, quantity, price}){

  const media_url = useContext(MEDIA_URL);
  let photo_preview = nomenclature.nomenclature.catalog_entry.photo_preview

  return (
    <div className="m-3 p-3 product-in-cart">
      <div className="row">
        <div className="col-2">
          <img src={photo_preview ? media_url + photo_preview : default_photo} alt="Product" className="rounded float-left" width="130" height="130"></img>
        </div>
        <div className="col-7 ps-5">

          <Link 
            className="lk-link" 
            to={`/product/` + nomenclature.id}
            target="_blank" 
            rel="noopener noreferrer"
          >
            <div className="mx-1 mb-1">
              <div className="fw-bold fsvok3-t"> {nomenclature.nomenclature.catalog_entry.catalog_number} </div>
            </div>
          </Link> 
          <div className="m-1" style={{height: "55px"}}>
              <div className="lh-1"> {nomenclature.nomenclature.name}</div>
          </div>

          <div className="m-1">   
            <button className="lk-svg-button mt-2 mx-1 p-1" onClick={() => removeProductClick(nomenclature.id)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
              </svg>
            </button>       
          </div>  
        </div>
        <div className="col-3">
          <div className="float-end"><b>{price}</b> рублей</div>  
          <div className='btn-group float-end mt-2'>
            <button className="lk-svg-button"  onClick={() => DecreaseProductCountClick(nomenclature.id)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="" viewBox="0 0 16 16">
                <path  fillRule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
              </svg>
            </button>
            <div className='sc-quantity mx-2 py-1 px-2'>
              <b className="m-2">{quantity}</b>
            </div>
            <button className="lk-svg-button"  onClick={() => IncreaseProductCountClick(nomenclature.id)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="" viewBox="0 0 16 16">
                <path  fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
              </svg>
            </button>
          </div>  
        </div>
      </div>  
    </div>   
  )
}

function ShoppingCart ({addedProducts, goodsList, order, removeProductClick, IncreaseProductCountClick, DecreaseProductCountClick, selectedYear}) {

  const navigate = useNavigate();
  const api_url = useContext(API_URL); 
  let rows = [];
  let positions = addedProducts ? addedProducts.length : 0;
  let priceSum = 0;
  const token = useContext(AUTH_TOKEN);
 
  function CreateOrderClick(year) {
    //console.log("Приказываю создать заказ!")
    let year_obj = {'year': year}

    axios_api.post(api_url + `/order`,  year_obj, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        console.log("Order created");
        navigate("/order");
        navigate(0);
      },
      (error) => {
        console.log(error);
        navigate("/shopping_cart");
      }
    );
  }

  let index = undefined;
  for (let elem in addedProducts){

    index = goodsList.findIndex(item => item.id === addedProducts[elem].nomenclature_price);
    if (index >= 0) {
      let position_price = goodsList[index].price * addedProducts[elem].quantity;

      // номенклатуры ВНУК
      if (goodsList[index].nomenclature.type === "ВНУК") {
        position_price = position_price + goodsList[index].nomenclature.base_price;
      }

      priceSum += position_price;

      rows.push(
        <ProductInCart     
          key={goodsList[index].id} 
          nomenclature={goodsList[index]} 
          removeProductClick={removeProductClick}
          IncreaseProductCountClick={IncreaseProductCountClick}
          DecreaseProductCountClick={DecreaseProductCountClick}
          quantity={addedProducts[elem].quantity}
          price={position_price}
        />
      );
    }
  }  

  let rowsLength = rows.length;

  return (
    <>
      <div className="row">
        <h3 className="m-3">Корзина</h3>
      </div>
      <div className="row">
        {rowsLength ?       
          <div className="col-xxl-6 col-8">{rows}</div> 
          :
          <div className="col-xxl-6 col-8">
            <p className="m-5 text-center">Добавьте элементы в корзину из каталога</p>
          </div>
        }
        <div className="col-xxl-3 col-3">
          <OrderPanel
            positions={positions} 
            priceSum={priceSum}
            CreateOrderClick={CreateOrderClick} 
            order={order}
            selectedYear={selectedYear}
          />             
        </div>  
        <div className="col-xxl-3 col-1">
        </div>
      </div>        
    </>
  );
}

export default ShoppingCart;

